import { useSyncExternalStore } from 'react';

let isOpen = false;
const listeners = new Set<() => void>();

function notifyListeners() {
  for (const listener of listeners) listener();
}

export function openMobileNavigation() {
  if (isOpen) return;
  isOpen = true;
  notifyListeners();
}

export function closeMobileNavigation() {
  if (!isOpen) return;
  isOpen = false;
  notifyListeners();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) isOpen = false;
  };
}

export function useMobileNavigationOpen(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => isOpen,
    () => false,
  );
}
